import { DirectSalesStatusOption } from 'components/common/types/DirectSalesCampaign.types';

export const PRICED_STATUSES = [
  DirectSalesStatusOption.DRAFT_PRICED,
  DirectSalesStatusOption.PROPOSAL,
  DirectSalesStatusOption.OPTION,
  DirectSalesStatusOption.CONFIRMED,
  DirectSalesStatusOption.CANCELLED,
  DirectSalesStatusOption.LIVE,
  DirectSalesStatusOption.ENDED,
];

export const POST_ALLOCATION_STATUSES = [
  ...PRICED_STATUSES,
  DirectSalesStatusOption.MIXED,
  DirectSalesStatusOption.DRAFT_FAILED_SOLVE,
  DirectSalesStatusOption.DRAFT_FAILED_PRICE,
];
